/* @ngInject */
export function PersonalEquipmentTestCommentFactory() {
    return function PersonalEquipmentTestComment() {

        this.id = null;
        this.text = null;
    };
}
